import React, {useContext} from 'react';
import {OrderContext} from "../../../context/OrderContext";
import OrderFileUploader from "./orderFileUploader";

const OrderUploadHandler = () => {
    const {order, orderEdit} = useContext(OrderContext);

    const settings = [
        {
            name: null,
            path: order?.createdByCompany+"/orders/"+order?.id.replaceAll("-", '/')+"/documents"
        }
    ];

    return (
        <div>
            {settings?.map((setting, index) => (
                <div key={index}>
                    {OrderFileUploader(setting?.name,setting?.path,orderEdit, 'Dokumente und Plandaten', '', true, order?.id, order?.createdByCompany, "documents")}
                </div>
            ))}
        </div>

    );
};

export default OrderUploadHandler;
